/**
 * Common styles
 */

// Material
import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  RadioGroup,
  TableContainer,
  TableHead,
  Typography,
  TextField,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

// Styled
export const LogoContainer = styled(Box)(({ theme }) => ({
  padding: '0 10px 60px 10px',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '40px',
  },
}));

export const LayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  background: theme.palette.background.default,
}));

export const ContentLayout = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  paddingTop: '20px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '20px',
  },
}));

export const WrapperInputOrMessage = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  width: '100%',
});

export const FormUserServices = styled('form')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'grid',
    gap: '20px',
  },
}));

export const WrapperContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '5px',
  width: '100%',
});

export const TypographyCustom = styled(Typography)(({ theme }) => ({
  marginBottom: '30px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '20px',
  },
}));

export const ServicesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '50px 0px',
  gap: '20px',
  [theme.breakpoints.down('sm')]: {
    padding: '30px 0px',
    gap: '10px',
  },
}));

export const ServiceItem = styled(Grid)(({ theme }) => ({
  padding: '29px 35px 35px 35px',
  borderRadius: '10px',
  backgroundColor: 'white',
  display: 'flex',
  borderTopWidth: '12px',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    borderTopWidth: '8px',
    padding: '23px 15px 20px 15px',
  },
}));

export const CustomGrid = styled(Grid)(({ servicesLength }: { servicesLength: number }) => ({
  justifyContent: servicesLength <= 3 ? 'space-between' : undefined,
  width: servicesLength <= 3 ? '80%' : '100%',
  margin: servicesLength <= 3 ? '0px auto' : undefined,
  '--Grid-columns': servicesLength <= 3 ? 9 : 12,
  '@media (max-width: 900px)': {
    '--Grid-columns': 12,
    width: '100%',
    margin: '0',
  },
  '@media (max-width: 576px)': {
    '--Grid-columns': 6,
  },
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingBottom: '29px',
  gap: '20px',
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    gap: '8px',
    paddingBottom: '25px',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '22px !important',
  lineHeight: '25px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px !important',
  },
}));

export const Content = styled(Typography)(({ theme }) => ({
  padding: '35px 0',
  fontWeight: '600',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px !important',
    padding: '20px 0',
  },
}));

export const Divider = styled('hr')({
  margin: '0px',
  border: '1px solid #DDDDDD',
});

export const RegisterButton = styled(Button)(({ theme }) => ({
  fontWeight: 'bold',
  height: '40px',
  padding: '0px 20px',
  borderRadius: '30px',
  width: '100%',
  fontSize: '18px',
  marginTop: 'auto',
  color: '#000000',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    height: '30px',
  },
}));

export const WrapperIcon = styled('img')(({ theme }) => ({
  width: '59px',
  height: 'auto',
  [theme.breakpoints.down('sm')]: {
    width: '50px',
  },
}));

export const PageContainer = styled(Box)(({ theme }) => ({
  padding: '0 50px',
  [theme.breakpoints.down('sm')]: {
    padding: '0 20px',
  },
}));

export const PageNavigateContainer = styled(Box)(({ theme }) => ({
  padding: '20px 44px 0px 74px',
  [theme.breakpoints.down('md')]: {
    padding: '20px 34px 0px 44px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 20px',
  },
}));
export const WrapperScroll = styled(Box)({
  padding: '10px',
  borderRadius: '10px',
  background: '#FFFFFF',
});

export const WrapperItems = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  padding: '0px 26px',
  borderRadius: '10px',
  [theme.breakpoints.down('sm')]: {
    padding: '0px',
  },
}));

export const WrapperSystem = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '10px',
  [theme.breakpoints.down('sm')]: {
    padding: '0 20px',
  },
}));

export const WrapperServices = styled(Box)(({ theme }) => ({
  padding: '10px 0',
  maxHeight: 'calc(100vh - 190px)',
  [theme.breakpoints.down('sm')]: {
    display: 'grid',
    gap: '30px',
  },
}));

export const WrapperContentSystem = styled(Box)(({ theme }) => ({
  padding: '10px 0px 0px 150px',
  maxHeight: 'calc(100vh - 190px)',
  [theme.breakpoints.down('lg')]: {
    display: 'grid',
    gap: '30px',
    padding: 0,
  },
}));

export const ContentSystem = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  padding: '14px 10px 14px 0',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'start',
  justifyItems: 'center',
  flexDirection: 'column',
  gap: '34px',
  [theme.breakpoints.down('sm')]: {
    padding: '10px 20px',
    gap: '14px',
    marginTop: '14px',
    flex: 1,
  },
}));

export const ContentSystemItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyItems: 'center',
  gap: '100px',
  [theme.breakpoints.down('sm')]: {
    padding: '0',
    gap: '20px',
  },
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  marginTop: '3px !important',
  color: theme.palette.error.main,
}));

export const ImageContentSystem = styled('img')(({ theme }) => ({
  width: '54px',
  height: 'auto',
  [theme.breakpoints.down('sm')]: {
    padding: '0 20px',
  },
}));

export const SystemIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  gap: '12px',
  [theme.breakpoints.down('sm')]: {
    padding: '0 20px',
  },
}));

export const TypographySystem = styled(Typography)(({ theme }) => ({
  color: '#666666',
  fontWeight: '500',
  minWidth: '200px',
  [theme.breakpoints.down('sm')]: {
    minWidth: '120px',
  },
}));

export const RadioGroupContainer = styled(RadioGroup)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  gap: '56px',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    gap: '30px',
  },
}));

export const WrapperForm = styled('form')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#FFFFFF',
  boxShadow: '24px',
  padding: '32px',
  borderRadius: '10px',
  width: '670px',
  [theme.breakpoints.down('sm')]: {
    width: '98%',
    padding: '20px 10px',
  },
}));

export const BpIcon = styled('span')({
  display: 'inline-flex',
  borderRadius: '50%',
  width: 20,
  height: 20,
  boxShadow: 'inset 0 0 0 1px #ccc, inset 0 -1px 0 #ccc',
  'input:hover ~ &': {
    backgroundColor: '#ebf1f580',
  },
});

export const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#6EC8E2',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  boxShadow: 'unset',
  '&::before': {
    display: 'block',
    width: 20,
    height: 20,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#6EC8E2',
  },
});

export const CustomTableHead = styled(TableHead)({
  '& th:first-of-type': {
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
  },
  '& th:last-of-type': {
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
  },
});

export const CustomTableContainer = styled(TableContainer)(({ theme }) => ({
  border: '1px solid #DDDDDD',
  borderRadius: '15px',
  padding: '15px 15px 6px 15px',
  background: theme.palette.background.paper,
}));

export const WrapperSearchAndButton = styled(Box)<{ type?: 'primary' | 'secondary' | 'default' }>(
  ({ theme, type }) => ({
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    [theme.breakpoints.down('xl')]: {
      marginBottom: type === 'secondary' ? '0px' : '',
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
      flexDirection: type === 'primary' ? 'column' : 'row',
      alignItems: type === 'primary' ? 'start' : '',
      gap: type === 'primary' ? '12px' : '',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: type === 'secondary' ? 'row' : 'column',
      alignItems: 'start',
      gap: '12px',
    },
  })
);

export const RecordsContainer = styled(Box)<{ type?: 'primary' | 'secondary' | 'default' }>(
  ({ theme, type }) => ({
    display: 'flex',
    marginBottom: '20px',
    [theme.breakpoints.down('xl')]: {
      flexDirection: type === 'secondary' ? 'column-reverse' : '',
      gap: type === 'secondary' ? '20px' : '',
      marginBottom: type === 'secondary' ? '10px' : '',
    },
    [theme.breakpoints.down('lg')]: {
      flexDirection: type === 'primary' ? 'column-reverse' : '',
      gap: type === 'primary' ? '20px' : '',
      marginBottom: type === 'primary' ? '10px' : '',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      gap: '20px',
      marginBottom: '10px',
    },
  })
);

export const WrapperSearchAndBtnProcess = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'start',
  },
}));

export const WrapperSearch = styled(Box)(({ theme }) => ({
  width: '500px',
  [theme.breakpoints.down('lg')]: {
    width: '400px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const WrapperSelectInput = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginBottom: '45px',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: '35px',
    width: '100%',
  },
}));

export const ButtonProcess = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  backgroundColor: '#5ABDD880',
  color: '#000000',
  boxShadow: 'none',
  height: '58px',
  fontSize: '16px',
  padding: '10px 20px',
  textWrap: 'nowrap',
  marginLeft: '70px',
  [theme.breakpoints.down('lg')]: {
    marginLeft: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: '0px',
    height: '45px',
    fontSize: '14px',
  },
  '& .MuiSvgIcon-fontSizeMedium': {
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
}));

export const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    height: '100%',
    width: '100%',
    alignItems: 'flex-start',
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      height: '50px',
      padding: '0 16.5px',
    },
  },
}));

export const BoxNoDataList = styled(Box)({
  fontWeight: 'bold',
  height: '250px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const ButtonUpdate = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  float: 'right',
  width: '150px',
  height: '50px',
  marginTop: '32px',
  fontSize: '16px',
  [theme.breakpoints.down('sm')]: {
    width: '110px',
    height: '40px',
  },
}));
